import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'configuracao-notificacao-email');

const configuracaoNotificacaoEmail = {
  atualizar: { method: 'PUT', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoNotificacaoEmail);



// WEBPACK FOOTER //
// ./src/common/resources/configuracao/configuracao-notificacao-email.js